import { qs } from "@fluorescent/dom";
import Delegate from "ftdomdelegate";
import { emit } from "@/neon/events";

const selectors = {
  drawerTrigger: "[data-store-availability-modal-trigger]",
  drawer: "[data-store-availability-modal]",
  productTitle: "[data-store-availability-product-title]",
  storeList: "[data-store-availability-list-content]",
};

const storeAvailability = (container, product, variant, options) => {
  let storeList = null;
  let currentVariant = variant;

  const delegate = new Delegate(container);

  const _clickHandler = e => {
    e.preventDefault();

    emit("availability:showMore", () => ({
      product,
      variant: currentVariant,
      storeList,
      options,
    }));
  };

  const update = (variant, delayUpdate = false) => {
    currentVariant = variant;
    const variantSectionUrl = `${container.dataset.baseUrl}/variants/${variant.id}/?section_id=store-availability`;

    if (!delayUpdate) {
      container.innerHTML = "";
    }

    fetch(variantSectionUrl)
      .then(response => {
        return response.text();
      })
      .then(storeAvailabilityHTML => {
        if (storeAvailabilityHTML.trim() === "") {
          if (delayUpdate) {
            container.innerHTML = "";
          }
          return;
        }

        // Remove section wrapper that throws nested sections error
        container.innerHTML = storeAvailabilityHTML.trim();
        container.innerHTML = container.firstElementChild.innerHTML;

        storeList = qs(selectors.storeList, container);
      });
  };

  // Intialize
  update(variant);
  delegate.on("click", selectors.drawerTrigger, _clickHandler);

  const unload = () => {
    container.innerHTML = "";
  };

  return { unload, update };
};

export default storeAvailability;
